
import axios from 'axios';
import { getToken } from 'redux/sagas/selectors';
import { store } from 'redux/store';
const baseURL = process.env.REACT_APP_API_ROOT;

//  creates an instance of axios to use throughout the app for http requests
const api = axios.create({
    baseURL,
    headers: {
        Accept: 'application/json'
    },
});


// Add a request interceptor to include the token in every request
api.interceptors.request.use(
    (config) => {
        const state = store.getState();
        const token = getToken(state);
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export { api };